import { captureError } from "@/lib/sentry";

export const logError = (
  context: string,
  error: unknown,
  extra?: Record<string, unknown>,
): void => {
  if (import.meta.env.DEV) {
    console.error(`[${context}]`, error, extra);
    return;
  }

  const message = error instanceof Error ? error.message : String(error);
  console.error(`[${context}] ${message}`);

  captureError(error, { context, ...(extra ?? {}) });
};

/**
 * Get a user-friendly error message
 * @param error - The error object
 * @returns A sanitized message safe to show to users
 */
export const getUserMessage = (error: unknown): string => {
  // Return generic messages based on common error patterns
  if (error instanceof Error) {
    // Check for common Supabase auth errors
    if (error.message.includes("Invalid login credentials")) {
      return "Email o contraseña incorrectos";
    }
    if (error.message.includes("Email not confirmed")) {
      return "Por favor, confirmá tu email antes de iniciar sesión";
    }
    if (error.message.includes("User already registered")) {
      return "Ya existe una cuenta con ese email";
    }
    if (error.message.includes("Password should be")) {
      return "La contraseña debe tener al menos 6 caracteres";
    }

    // Payment/checkout specific
    if (error.message.includes("No authorization header")) {
      return "No pudimos validar tu sesión. Cerrá sesión e iniciá nuevamente.";
    }
    if (error.message.includes("Mercado Pago error")) {
      return "Mercado Pago rechazó la operación. Revisá los datos de la cuenta e intentá otra vez.";
    }
    if (error.message.includes("Tu sesión expiró")) {
      return "Tu sesión expiró. Volvé a iniciar sesión para continuar.";
    }
  }

  // Default generic message
  return "Ocurrió un error. Por favor, intentá de nuevo.";
};
